module.exports = __webpack_public_path__ + "img/cu_logo_black.bfa881aa.png";